import React from 'react';
import web_logo from '../assets/img/tg_logo/web.png';
import andorid_logo from '../assets/img/tg_logo/android.png';
import ios_logo from '../assets/img/tg_logo/ios.png';

const Services = () => {

    const items = [
        {title: 'Web Solution', image: web_logo},
        {title: 'Website Design', image: web_logo},
        {title: 'Website Development', image: web_logo},
        {title: 'Personal Website', image: web_logo},
        {title: 'Professional Website', image: web_logo},
        {title: 'Business Website', image: web_logo},
        
        {title: 'Restful API', image: web_logo},
        {title: 'Database Design', image: web_logo},

        {title: 'Android Solution', image: andorid_logo},
        {title: 'Android Apps Design', image: andorid_logo},
        {title: 'Android Apps Development', image: andorid_logo},

        {title: 'IOS Solution', image: ios_logo},
        {title: 'IOS Apps Design', image: ios_logo},
        {title: 'IOS Apps Develoment', image: ios_logo},
    ]


    return (
        <section className="my-5 py-10 px-2 sm:px-4 md:px-8 lg:px-12 xl:px-14">
            {/* <h2 className="my-2 p-3 bg-white shadow-md text-center text-xl md:text-3xl font-extrabold">Technology</h2> */}
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 justify-center gap-4 lg:gap-6">
                {items.map((item,index) => (
                    <div key={index} className="bg-white shadow-md hover:shadow-lg animate__animated animate__zoomInUp">
                        <div className="p-2 sm:p-4 md:p-6 lg:p-8">
                            <img src={item.image} alt={item.title} className="mx-auto max-h-24 transition duration-1000 hover:scale-110" />
                        </div>
                        <h2 className="text-center px-2 py-4 text-slate-900 font-bold text-lg md:text-xl">{item.title}</h2>
                    </div>
                ))}

            </div>
        </section>
    )
}

export default Services